import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import SettingsPage from './Settings'

const Pages: React.FC = () => {
  return (
    <Switch>
      <Route component={SettingsPage} exact path="/settings" />
      <Route>
        <Redirect to="/settings" />
      </Route>
    </Switch>
  )
}

export default Pages
